import types from "./types";

const INITIAL_STATE = {
	employee_evaluation: null,
	employee_evaluationError: null,
	employee_evaluationLoading: false,

	//create
	createemployee_evaluation: null,
	createemployee_evaluationError: null,
	createemployee_evaluationLoading: false,

	//update
	updateemployee_evaluation: null,
	updateemployee_evaluationError: null,
	updateemployee_evaluationLoading: false,

	//delete
	deleteemployee_evaluation: null,
	deleteemployee_evaluationError: null,
	deleteemployee_evaluationLoading: false,

	//single item

	singleItem: null,
};

const EmployeeEvaluationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_EMPLOYEE_EVALUATION_START:
			return {
				...state,
				employee_evaluation: null,
				employee_evaluationError: null,
				employee_evaluationLoading: true,
			};
		case types.GET_EMPLOYEE_EVALUATION_SUCCESS:
			return {
				...state,
				employee_evaluation: action.payload,
				employee_evaluationLoading: false,
			};
		case types.GET_EMPLOYEE_EVALUATION_ERROR:
			return {
				...state,
				employee_evaluationError: action.payload,
				employee_evaluationLoading: false,
			};
		case types.GET_EMPLOYEE_EVALUATION_RESET:
			return {
				...state,
				employee_evaluationError: null,
				employee_evaluationLoading: false,
			};
		//create

		case types.CREATE_EMPLOYEE_EVALUATION_START:
			return {
				...state,
				createemployee_evaluation: null,
				createemployee_evaluationError: null,
				createemployee_evaluationLoading: true,
			};
		case types.CREATE_EMPLOYEE_EVALUATION_SUCCESS:
			return {
				...state,
				createemployee_evaluation: action.payload,
				createemployee_evaluationLoading: false,
			};
		case types.CREATE_EMPLOYEE_EVALUATION_ERROR:
			return {
				...state,
				createemployee_evaluationError: action.payload,
				createemployee_evaluationLoading: false,
			};
		case types.CREATE_EMPLOYEE_EVALUATION_RESET:
			return {
				...state,
				createemployee_evaluationError: null,
				createemployee_evaluationLoading: false,
			};
		//delete

		case types.DELETE_EMPLOYEE_EVALUATION_START:
			return {
				...state,
				deleteemployee_evaluation: null,
				deleteemployee_evaluationError: null,
				deleteemployee_evaluationLoading: true,
			};
		case types.DELETE_EMPLOYEE_EVALUATION_SUCCESS:
			return {
				...state,
				deleteemployee_evaluation: action.payload,
				deleteemployee_evaluationLoading: false,
			};
		case types.DELETE_EMPLOYEE_EVALUATION_ERROR:
			return {
				...state,
				deleteemployee_evaluationError: action.payload,
				deleteemployee_evaluationLoading: false,
			};
		case types.DELETE_EMPLOYEE_EVALUATION_RESET:
			return {
				...state,
				deleteemployee_evaluation: null,
				deleteemployee_evaluationError: null,
				deleteemployee_evaluationLoading: false,
			};

		//update
		case types.UPDATE_EMPLOYEE_EVALUATION_START:
			return {
				...state,
				updateemployee_evaluation: null,
				updateemployee_evaluationError: null,
				updateemployee_evaluationLoading: true,
			};
		case types.UPDATE_EMPLOYEE_EVALUATION_SUCCESS:
			return {
				...state,
				updateemployee_evaluation: action.payload,
				updateemployee_evaluationLoading: false,
			};
		case types.UPDATE_EMPLOYEE_EVALUATION_ERROR:
			return {
				...state,
				updateemployee_evaluationError: action.payload,
				updateemployee_evaluationLoading: false,
			};
		case types.UPDATE_EMPLOYEE_EVALUATION_RESET:
			return {
				...state,
				updateemployee_evaluation: null,
				updateemployee_evaluationError: null,
				updateemployee_evaluationLoading: false,
			};
		//singleItem
		// case types.SINGLE_EMPLOYEE_EVALUATION_START:
		// 	return {
		// 		...state,
		// 		updateemployee_evaluation: null,
		// 		updateemployee_evaluationError: null,
		// 		updateemployee_evaluationLoading: true,
		// 	};
		// case types.SINGLE_EMPLOYEE_EVALUATION_SUCCESS:
		// 	return {
		// 		...state,
		// 		updateemployee_evaluation: action.payload,
		// 		updateemployee_evaluationLoading: false,
		// 	};
		// case types.SINGLE_EMPLOYEE_EVALUATION_ERROR:
		// 	return {
		// 		...state,
		// 		updateemployee_evaluationError: action.payload,
		// 		updateemployee_evaluationLoading: false,
		// 	};
		// case types.SINGLE_EMPLOYEE_EVALUATION_RESET:
		// 	return {
		// 		...state,
		// 		updateemployee_evaluationError: null,
		// 		updateemployee_evaluationLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default EmployeeEvaluationReducer;
